// Kept apart from PlanningReportsApp so main.jsx can test the path without
// loading the app (and its styles) on every page.
export function isReportsPath(pathname) {
  return /^\/reports(\/|$)/i.test(pathname);
}
